






























































































































import moment from 'moment';
import Pagination from '../subComponents/Pagination/Pagination.vue';
import { PRODUCT_UNIT_TRUST } from '../../utils/fieldMappers/constants';
import { formatCurrency, formatUnits, formatUnitPrice } from '../../utils/fieldMappers/formatValue';
export default {
  name: 'Transactions',
  components: {
    Pagination,
  },
  props: ['data'],
  data: () => ({
    moment,
    formatCurrency,
    formatUnits,
    formatUnitPrice,
  }),
  computed: {
    displayPagination() {
      return this.data.transactions.totalPages > 1 ? true : false;
    },
    nbPageVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 7;
      } else {
        if (this.data.transactions.totalPages > 9) {
          return 9;
        } else {
          return this.data.transactions.totalPages;
        }
      }
    },
  },
  methods: {
    getTransactions(pageNumber) {
      this.$emit('getTransactions', pageNumber);
    },
    isUnitTrust() {
      return this.data.investment.accountProductType === PRODUCT_UNIT_TRUST;
    },
  },
};
